<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddGroup()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_group.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditGroup()" v-if="permissionList.includes(permission.edit)">{{$t('setting_group.table_edit')}}</b-button>
                            <b-button variant="primary" size="lg" class="ml-1" @click="getAttributeGroup()">{{$t('setting_group.table_group_attribute')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteGroup()" v-if="permissionList.includes(permission.delete)">{{$t('setting_group.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addGroup" :title="$t('setting_group.table_add')" @ok="addGroup" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')" size="lg">
                    <form id="addGroupForm" @submit.prevent="addGroup">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <b-form-input name="code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxAdd.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" v-model="ajaxAdd.status" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_display_risk')}}</template>
                            <b-form-select name="display_risk">
                                <option value="high">High</option>
                                <option value="medium">Medium</option>
                                <option value="low">Low</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_display_rate')}}</template>
                            <b-form-input name="display_rate"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_stop_rate')}}</template>
                            <b-form-input name="stop_rate"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('tools.permission')}}</template>
                            <b-form-checkbox-group name="permission[]">
                                <b-form-checkbox value="entrust" class="mt-2">entrust</b-form-checkbox>
                                <b-form-checkbox value="terminate" class="mt-2">terminate</b-form-checkbox>
                                <b-form-checkbox value="renew" class="mt-2">renew</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('admin.table_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('admin.table_title')}}</template>
                                        <b-form-input :name="'title[' + lang.code + ']'"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('admin.table_content')}}</template>
                                        <b-form-textarea :name="'content[' + lang.code + ']'" rows="6"></b-form-textarea>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editGroup" :title="$t('setting_group.table_edit')" @ok="editGroup" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')" size="lg">
                    <form id="editGroupForm" @submit.prevent="editGroup">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxEdit.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" v-model="ajaxEdit.status" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_display_risk')}}</template>
                            <b-form-select name="display_risk" v-model="ajaxEdit.display_risk">
                                <option value="high">High</option>
                                <option value="medium">Medium</option>
                                <option value="low">Low</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_display_rate')}}</template>
                            <b-form-input name="display_rate" v-model="ajaxEdit.display_rate"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_stop_rate')}}</template>
                            <b-form-input name="stop_rate" v-model="ajaxEdit.stop_rate"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('sidebar.tools.permission')}}</template>
                            <b-form-checkbox-group name="permission[]"  v-model="ajaxEdit.permission">
                                <b-form-checkbox value="entrust" class="mt-2">entrust</b-form-checkbox>
                                <b-form-checkbox value="terminate" class="mt-2">terminate</b-form-checkbox>
                                <b-form-checkbox value="renew" class="mt-2">renew</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('admin.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('admin.table_name')}}</template>
                                        <b-form-input :name="'title[' + lang.code + ']'" v-model="ajaxEdit.title[lang.code]"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('admin.table_content')}}</template>
                                        <b-form-textarea :name="'content[' + lang.code + ']'" rows="6" v-model="ajaxEdit.content[lang.code]"></b-form-textarea>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="getAttributeGroup" :title="$t('setting_group.table_attribute_title',{attribute:ajaxAttributeGroup})" size="lg " hide-footer>
                    <b-tabs class="center_pane" justified fill>
                        <b-tab :title="$t('setting_group.table_attribute')" active>
                            <el-table class="custom-table" :data="ajaxAttributeTable" @expand-change="expandChangeAttribute" @row-click="expandRowAttribute" ref="tableAttribute" border>
                                <el-table-column v-for="title in attributeTitles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width"></el-table-column>
                                <el-table-column type="expand">
                                    <b-button variant="info" @click="getEditAttributeGroup()" v-if="permissionList.includes(permission.attribute_edit)">{{$t('setting_group.table_edit_attribute')}}</b-button>
                                    <b-button variant="danger" class="ml-1" @click="deleteAttributeGroup()" v-if="permissionList.includes(permission.attribute_delete)">{{$t('setting_group.table_delete_attribute')}}</b-button>
                                </el-table-column>
                            </el-table>
                            <div class="mt-3">
                                <span class="float-left">{{$t('admin.table_show_result',{result:ajaxAttributeTool.total_number})}}</span>
                                <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationAttributeSizeChange" @current-change="paginationAttributeCurrentChange" :current-page.sync="ajaxAttributeTool.current_pagination" :total="ajaxAttributeTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                            </div>
                        </b-tab>
                        <b-tab :title="$t('setting_group.table_add_attribute')">
                            <form id="addAttributeGroup" @submit.prevent="addAttributeGroup">                            
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_coin')}}</template>
                                    <b-form-select name="coin_id">
                                        <option>-</option>
                                        <option v-for="(list,index) in ajaxAttributeList" :key="index" :value="list.id">[{{list.code}}] - {{list.name}}</option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_amount')}}</template>
                                    <b-form-input name="amount"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">Margin</template>
                                    <b-form-input name="margin"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('admin.table_status')}}</template>
                                    <b-form-checkbox name="status" size="lg" value="1" v-model="ajaxEdit.status" unchecked-value="0" switch></b-form-checkbox>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('sidebar.tools.permission')}}</template>
                                    <b-form-checkbox-group name="permission[]"  v-model="ajaxEdit.permission">
                                        <b-form-checkbox value="entrust" class="mt-2">entrust</b-form-checkbox>
                                        <b-form-checkbox value="terminate" class="mt-2">terminate</b-form-checkbox>
                                        <b-form-checkbox value="renew" class="mt-2">renew</b-form-checkbox>
                                    </b-form-checkbox-group>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <b-button variant="primary" @click="addAttributeGroup()" v-if="permissionList.includes(permission.attribute_add)">{{$t('button.submit')}}</b-button>
                                </b-form-group>
                            </form>
                        </b-tab>
                    </b-tabs>
                </b-modal>
                <b-modal id="getEditAttributeGroup" :title="$t('setting_group.table_edit_attribute')" @ok="editAttributeGroup" hide-footer>
                    <form id="editAttributeGroup" @submit.prevent="editAttributeGroup">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_coin')}}</template>
                            <b-form-select name="coin_id" v-model="ajaxAttributeEdit.coin_id">
                                <option>-</option>
                                <option v-for="(list,index) in ajaxAttributeList" :key="index" :value="list.id">[{{list.code}}] - {{list.name}}</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_amount')}}</template>
                            <b-form-input name="amount" v-model="ajaxAttributeEdit.amount"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">Margin</template>
                            <b-form-input name="margin" v-model="ajaxAttributeEdit.margin"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" v-model="ajaxAttributeEdit.status" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('sidebar.tools.permission')}}</template>
                            <b-form-checkbox-group name="permission[]"  v-model="ajaxAttributeEdit.permission">
                                <b-form-checkbox value="entrust" class="mt-2">entrust</b-form-checkbox>
                                <b-form-checkbox value="terminate" class="mt-2">terminate</b-form-checkbox>
                                <b-form-checkbox value="renew" class="mt-2">renew</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-button variant="primary" @click="editAttributeGroup()">{{$t('button.submit')}}</b-button>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,groupAjaxTable,groupAdd,getGroupEdit,groupEdit,groupDelete,groupAttributeAjaxTable,groupAttributeAdd,getGroupAttributeEdit,groupAttributeEdit,groupAttributeDelete,groupAttributeLimit,groupAttributePagination} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',remark:'',sort:'',status:'',name:''},
            ajaxAdd:{sort:10,status:0,languageList:[]},
            ajaxEdit:{languageList:[]},
            ajaxRow:'',
            ajaxAttributeTable:[],
            ajaxAttributeGroup:[],
            ajaxAttributeTool:[],
            ajaxAttributeSearch:[],
            ajaxAttributeEdit:[],
            ajaxAttributeList:[],
            ajaxAttributeRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'3C5F77',
                edit:'840754',
                delete:'D240EF',
                attribute_add:'53D734',
                attribute_edit:'B7E3F2',
                attribute_delete:'05F934'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width: '5'
            },{
                prop: "code",
                label: this.$t('admin.table_code'),
                width: '10'
            },{
                prop: "name",
                label: this.$t('admin.table_name'),
                width: '10'
            },{
                prop: "sort",
                label: this.$t('admin.table_sort'),
                width: '10'
            },{
                prop: "status",
                label: this.$t('admin.table_status'),
                width: '5'
            }], 
            attributeTitles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width: '83'
            },{
                prop: "coin_name",
                label: this.$t('admin.table_coin'),
                width: '83'
            },{
                prop: "status",
                label: this.$t('admin.table_status'),
                width: '83'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = groupAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.remark,this.ajaxSearch.sort,this.ajaxSearch.status,this.ajaxSearch.name);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddGroup(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = languageList();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.ajaxAdd.languageList = value.data;
                        self.$bvModal.show('addGroup')
                    }
                });
            }
        },addGroup(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                var form = document.getElementById('addGroupForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = groupAdd(formData);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }
                });    
            }        
        },getEditGroup(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getGroupEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editGroup');
                        self.ajaxEdit = value.data;
                        self.ajaxEdit.languageList = value.language;
                        console.log(self.ajaxEdit.permmission);
                    }else{
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text,
                        });
                    }
                })
            }
        },editGroup(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                var form = document.getElementById('editGroupForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('id', this.ajaxEdit.id); 
                var result = groupEdit(formData);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }
                })
            }
        },deleteGroup(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = groupDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.limit = this.pageLimit;
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        },expandRowAttribute(row){
            this.$refs.tableAttribute.toggleRowExpansion(row);
            this.ajaxAttributeRow = row.id
        },expandChangeAttribute(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },getAttributeGroup(){
            var self = this;
            var result = groupAttributeAjaxTable(this.ajaxRow);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                self.$bvModal.show('getAttributeGroup');
                self.ajaxAttributeTable = value.data.datatable.data;
                self.ajaxAttributeList = value.data.coin_list;
                self.ajaxAttributeGroup = value.data.group.code;
                self.ajaxAttributeTool = value.data.datatable;
                self.csrfName = value.data.csrf_list.csrf_name;
                self.csrfValue = value.data.csrf_list.csrf_value;
                self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                self.csrfValueKey = value.data.csrf_list.csrf_value_key;
            });
        },addAttributeGroup(){
            if(this.permissionList.includes(this.permission.attribute_add)){
                var self = this;
                var form = document.getElementById('addAttributeGroup');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('group_id', this.ajaxRow); 
                var result = groupAttributeAdd(formData);
                self.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {                      
                                self.getAttributeGroup();
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.getAttributeGroup();
                            }
                        });
                    }
                });
            }
        },getEditAttributeGroup(){
            if(this.permissionList.includes(this.permission.attribute_edit)){
                var self = this;
                var result = getGroupAttributeEdit(this.ajaxAttributeRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('getEditAttributeGroup');
                    self.ajaxAttributeEdit = value.data;
                });
            }
        },editAttributeGroup(){
            if(this.permissionList.includes(this.permission.attribute_edit)){
                var self = this;
                var form = document.getElementById('editAttributeGroup');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('id', this.ajaxAttributeEdit.id); 
                formData.append('group_id', this.ajaxRow); 
                var result = groupAttributeEdit(formData);
                self.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.$bvModal.hide('getEditAttributeGroup');                            
                                self.getAttributeGroup();
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.$bvModal.hide('getEditAttributeGroup');
                                self.getAttributeGroup();
                            }
                        });
                    }
                });
            }
        },deleteAttributeGroup(){
            if(this.permissionList.includes(this.permission.attribute_delete)){
                this.$swal.fire({
                    text: this.$t('msg.confirm_delete'),
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: this.$t('button.confirm'),
                    cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxAttributeRow); 
                        var result = groupAttributeDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.getAttributeGroup();
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.getAttributeGroup();
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },paginationAttributeSizeChange(limit){
            var self = this;
            var result = groupAttributeLimit(this.ajaxRow,limit);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.pageAttributeLimit = limit;
                    self.ajaxAttributeTable = value.data.datatable.data;
                    self.ajaxAttributeList = value.data.attribute_list;
                    self.ajaxAttributeGroup = value.data.group.code;
                    self.ajaxAttributeTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }
            });
        },paginationAttributeCurrentChange(current){
            var self = this;
            var result = groupAttributePagination(this.ajaxRow,current,this.pageAttributeLimit);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxAttributeTable = value.data.datatable.data;
                    self.ajaxAttributeList = value.data.attribute_list;
                    self.ajaxAttributeGroup = value.data.group.code;
                    self.ajaxAttributeTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }
            });
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
